export default __webpack_public_path__ + "static/media/NPSOn.72ae929b.png";